// Auth guards — the two pathless layout routes every authed/admin page hangs
// off. Mirrors FRONTEND_SPA_DESIGN.md §3b exactly:
//   - `_authed`: any signed-out hit on a guarded page -> `/sign-in?redirect_url=`
//     round-trip (the exact query contract every server shell uses today,
//     e.g. app/library/page.tsx:17).
//   - `_admin`: additionally requires `isAdmin`, else -> `/` (parity with
//     app/admin/layout.tsx:6). Siblings, not nested — `_admin` re-checks
//     `context.me` itself rather than requiring `_authed` as an ancestor,
//     matching the doc's flat route tree (§3a) where `_admin` sits directly
//     under root next to `_authed`.
//
// CONVENTION for sibling porters: every route in routes/agents.tsx uses
// `getParentRoute: () => authedRoute`; every route in routes/admin.tsx uses
// `getParentRoute: () => adminRoute`. Don't add new beforeLoad checks
// per-page — auth lives here, once.
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const authedRoute = createRoute({
  id: '_authed',
  getParentRoute: () => rootRoute,
  beforeLoad: async ({ context, location }) => {
    const me = await context.me;
    if (!me) {
      throw redirect({
        href: `/sign-in?redirect_url=${encodeURIComponent(location.href)}`,
      });
    }
    return { me };
  },
});

export const adminRoute = createRoute({
  id: '_admin',
  getParentRoute: () => rootRoute,
  beforeLoad: async ({ context }) => {
    const me = await context.me;
    if (!me?.isAdmin) {
      throw redirect({ href: '/' });
    }
    return { me };
  },
});
